import { Model, ModelAttributes, model, modelConfig, collection, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import Club from "./Club";
import FundingOutreach from "./FundingOutreach";
import FundingOutreachCommunicationAnalysis from "./FundingOutreachCommunicationAnalysis";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    body_html: {
      type: "string",
    },
    body_text: {
      type: "string",
    },
    channel: {
      type: "enum",
      enumType: "email" as Database["public"]["Enums"]["funding_outreach_communication_channel"],
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    direction: {
      type: "enum",
      enumType: "outbound" as Database["public"]["Enums"]["funding_outreach_communication_direction"],
    },
    from_email: {
      type: "string",
    },
    from_name: {
      type: "string",
    },
    funding_outreach_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    mailgun_message_id: {
      type: "string",
    },
    occurred_at: {
      type: "datetime",
    },
    opened_at: {
      type: "datetime",
    },
    sent_by_account_user_id: {
      type: "string",
    },
    subject: {
      type: "string",
    },
    to_email: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {
    analyses: collection(
      () => FundingOutreachCommunicationAnalysis as any,
      "funding_outreach_communication_id",
    ),
  },
  {
    account: reference(() => Account as any, "account_id"),
    club: reference(() => Club as any, "club_id"),
    funding_outreach: reference(() => FundingOutreach as any, "funding_outreach_id"),
    sent_by_account_user: reference(() => AccountUser as any, "sent_by_account_user_id"),
  },
);

interface FundingOutreachCommunication extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_outreach_communications", config)
class FundingOutreachCommunication extends Model<typeof config> {}

export default FundingOutreachCommunication;
